import React from 'react';
import {Box} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DechetTypeChip from '../../../app/components/layout/DechetTypeChip.js';
import ConteneurTypeChip from '../../../app/components/layout/ConteneurTypeChip.js';
import {FLUX_LIBELLES} from './fiche.selectors.js';

const PILULE = {height: 20, borderRadius: '999px', fontSize: 11, fontWeight: 800, letterSpacing: '.06em', '& .MuiChip-label': {px: '10px'}};

// Flux : badge existant du front (couleurs partagées). Typologie : badge conteneur existant, teinte navy pâle de la maquette.
export function BadgeFlux({flux}) {
    if (!flux) return null;
    return <DechetTypeChip type={flux} label={flux} title={FLUX_LIBELLES[flux] || flux} sx={PILULE}/>;
}

export function BadgeTypologie({typologie}) {
    if (!typologie) return null;
    return <ConteneurTypeChip type={typologie} sx={{...PILULE, bgcolor: '#E7ECF6', color: '#0F2D69', border: 'none'}}/>;
}

export function BadgeQuantite({quantite}) {
    if (quantite == null) return null;
    return (
        <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: '4px', px: '10px', height: 20, borderRadius: '999px', bgcolor: '#E7ECF6', color: '#0F2D69', fontSize: 11, fontWeight: 800}}>
            <DeleteOutlineIcon sx={{fontSize: 12}}/>{quantite}
        </Box>
    );
}
